import React from 'react';
import { ExpandOutlined } from '@ant-design/icons';
import styles from './Common.module.css';

/**
 * Reusable expand button component for charts and modals
 * @param {Object} props
 * @param {Function} props.onClick - Click handler
 * @param {string} props.title - Tooltip title (default: "Espandi grafico")
 * @param {string} props.className - Additional CSS class
 */
const ExpandButton = ({
  onClick,
  title = "Espandi grafico",
  className = ""
}) => {
  return (
    <button
      onClick={onClick}
      title={title}
      className={`${styles.expandButton} ${className}`}
    >
      <ExpandOutlined />
    </button>
  );
};

export default ExpandButton;
